import axios from 'axios';
import { getApiUrl } from './urls';
import axiosInstance from './axiosConfig';
import { performLogout } from './logoutUtils';
import { reportError } from '../sentry';

let currentToken: string | null | undefined = null;
let isRefreshing = false;
let refreshQueue: ((token: string | null) => void)[] = [];

export const getAccessToken = () => currentToken;

export const setAccessToken = (token: string | null) => {
  currentToken = token;
};

export const refreshAccessToken = async (): Promise<string | null> => {
  if (sessionStorage.getItem('isLoggedOut') === 'true') {
    console.warn('User logged out, skipping refresh');
    return null;
  }

  if (isRefreshing) {
    return new Promise((resolve) => {
      refreshQueue.push(resolve);
    });
  }

  isRefreshing = true;

  try {
    const response = await axios.post(
      '/auth/refresh-token',
      {},
      { withCredentials: true, baseURL: getApiUrl() }
    );

    setAccessToken(response.data.accessToken);
    isRefreshing = false;

    refreshQueue.forEach((resolve) => resolve(response.data.accessToken));
    refreshQueue = [];

    return response.data.accessToken;
  } catch (error) {
    reportError(error, { tags: { area: 'token_refresh' } });

    isRefreshing = false;
    refreshQueue.forEach((resolve) => resolve(null));
    refreshQueue = [];

    performLogout();

    return null;
  }
};

export const logoutSession = async (): Promise<string | null> =>
  axiosInstance.post('/auth/logout', {}, { withCredentials: true });
